import { TrendingUp, DollarSign, Users } from 'lucide-react';

const StatsSection = () => {
  const stats = [
    {
      icon: <TrendingUp className="w-12 h-12" />,
      number: 'R$10M+',
      label: 'Investidos em Tráfego Pago',
      description: 'Gerenciados nos últimos 5 anos'
    },
    {
      icon: <DollarSign className="w-12 h-12" />,
      number: '4-8x',
      label: 'ROAS Médio',
      description: 'Retorno sobre investimento em anúncios'
    },
    {
      icon: <Users className="w-12 h-12" />,
      number: '95%',
      label: 'Taxa de Satisfação',
      description: 'Clientes que renovam conosco'
    }
  ];

  return (
    <section className="py-16 bg-[#f5f5f5]">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {stats.map((stat, index) => (
            <div 
              key={index}
              className="text-center p-8 bg-white rounded-2xl shadow-lg border-2 border-gray-100 hover:border-way2go-accent transition-all duration-300 hover:shadow-xl transform hover:-translate-y-2"
              style={{ minHeight: '280px' }}
            >
              <div className="w-20 h-20 bg-gradient-to-br from-way2go-accent to-orange-600 rounded-2xl flex items-center justify-center text-white mx-auto mb-4">
                {stat.icon}
              </div>
              <p className="text-5xl font-bold text-way2go-primary mb-2">
                {stat.number}
              </p>
              <p className="text-xl font-semibold text-gray-700 mb-2">
                {stat.label}
              </p>
              <p className="text-sm text-gray-600">
                {stat.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
